import shopifyEmpireGenericDefaults from '../shopify-empire-generic/config.js';

const isOnPDP = window.location.pathname.startsWith('/products/');

function InitFunc() {
  shopifyEmpireGenericDefaults.InitFunc?.();

  // Empire dispatches a non-bubbling `variant-change` on <variant-selection>, so it is caught in the capture phase.
  window.document.addEventListener(
    'variant-change',
    ({ detail: { product, variant } = {} }) => {
      const productId = window.Convermax.Shopify?.getProductId?.();
      if (!variant?.id || !productId || product?.id !== productId) {
        return;
      }

      window.Convermax.updateVerifyFitmentWidget(productId, variant.id);
    },
    true,
  );
}

export default {
  includes: ['shopify-empire-generic'],
  ...shopifyEmpireGenericDefaults,
  InitFunc,
  Widgets: [
    ...shopifyEmpireGenericDefaults.Widgets.filter(
      (w) => !['VerifyFitment', 'VehicleWidgetDialog'].includes(w.name),
    ),
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/collapsibleVerifyFitment',
      isAlwaysColumnLayout: true,
      initCollapsed: false,
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
      doNotRedirectOnVehicleSelect: isOnPDP,
    },
  ],
};
